import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=90f45a68&scoped=true&"
import script from "./ImageViewer.vue?vue&type=script&lang=js&"
export * from "./ImageViewer.vue?vue&type=script&lang=js&"
import style0 from "./ImageViewer.vue?vue&type=style&index=0&id=90f45a68&lang=scss&scoped=true&"
import style1 from "./ImageViewer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f45a68",
  null
  
)

export default component.exports
import {QCheckbox,QIcon} from 'quasar'
component.options.components = Object.assign({QCheckbox,QIcon}, component.options.components || {})
